import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import { getUserId } from "../../services/helper"
import Button from "../../shared/button"
import { downloadBadge } from "./badge.download"

const Badge = () => {
  const params = useParams<{ badgeId: string }>()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (Number(params.badgeId))
      downloadBadge(getUserId(), Number(params.badgeId)).then(() =>
        setLoading(false)
      )
  }, [params.badgeId])

  return (
    <div style={{ textAlign: "center" }}>
      <p>
        {loading
          ? "Votre badge est en cours de téléchargement, veuillez patienter..."
          : "Téléchargement terminé"}
      </p>
      <p>
        Si votre téléchargement ne fonctionne, veuillez essayer le bouton
        ci-dessous
      </p>
      <Button
        style={{ marginTop: "0.5em" }}
        onClick={() =>
          downloadBadge(getUserId(), Number(params.badgeId)).then(() =>
            setLoading(false)
          )
        }
        label="Je veux relancer le téléchargement"
      />
    </div>
  )
}

export default Badge
